<template>
  <div>
    <div>
      <span class="xbed-sub-title">{{topTitle}}</span>
    </div>
    <br>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label='标签组:' :label-width='80'>
        <Select v-model="searchParams.tagGroupId" clearable filterable @on-change="changeTagGroupFn">
          <Option v-for="(item, index) in tagGroupAndTaglist" :value="item.groupId" :key="index">{{item.groupName}}</Option>
        </Select>
      </FormItem>
      <FormItem label='标签:' :label-width='80'>
        <Select v-model="searchParams.tagId" clearable filterable ref="tagSelector">
          <Option v-for="(item, index) in selectTagAry" :value="item.id" :key="index">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label='用户手机号:' :label-width='120'>
        <Input v-model="searchParams.phone"></Input>
      </FormItem>
      <FormItem :label-width="10">
        <Button type="primary" @click="getTagUserlistFn">查询</Button>
      </FormItem>
      <FormItem :label-width="10">
        <Button type="primary" @click="openAddTagUserModalFn">添加用户标签</Button>
      </FormItem>
    </Form>

    <div style="margin: 10px;overflow: hidden">
      <Page show-sizer show-total :page-size="pageParams.pageSize" :current="pageParams.pageNum" :total="pageParams.total" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>
    <Table stripe :columns="columnsList" :data='tagUserlist' :loading='isloading'></Table>

    <!-- 新增标签用户 -->
    <Modal v-model="addTagUserModal.display" ref="addTagUserModal" title="新增标签用户" @on-ok="preAddUserTagFn" :loading="true" cancel-text="关闭">
      <Form :model="addTagUserModal" ref="addForm" :rules="addTagUserModal.rules" :label-width="80">
        <FormItem label="手机号:" style="width:380px;" prop="phone">
          <Input v-model="addTagUserModal.phone" maxlength="11"></Input>
          <span class="colorUnderline" @click="checkPhoneRegisterFn">检查手机号是否已注册</span>
          <div v-if="phoneVerifyInfo.hadRequst && phoneVerifyInfo.verifyResult">检查结果：<span style="color:green;">已注册</span>（{{phoneVerifyInfo.verifyDate}}）</div>
          <div v-if="phoneVerifyInfo.hadRequst && !phoneVerifyInfo.verifyResult">检查结果：<span style="color:red;">未注册</span></div>
        </FormItem>
        <FormItem label="标签:" style="width:380px;" required>
          <Cascader :data="levelTaglist" change-on-select @on-change="handleTaguserFn" style="width: 270px;"></Cascader>
        </FormItem>
        <FormItem label="有效期:" required>
          <RadioGroup v-model="addTagUserModal.isTimeLimit">
            <Radio :label="0" style="width: 160px;">不限</Radio>
            <Radio :label="1" style="width: 160px;">限期</Radio>
          </RadioGroup>

          <DatePicker v-if="addTagUserModal.isTimeLimit==1" v-model="addTagUserModal.defaultDate" format="yyyy-MM-dd" type="daterange" 
            placeholder="开始日期～结束日期" style="width:250px; margin-top:20px;"></DatePicker>
        </FormItem>
      </Form>
    </Modal>

    <!-- 编辑标签用户 -->
    <Modal v-model="editTagUserModal.display" title="编辑标签用户" @on-ok="preEditUserTagFn" :loading="true" okText="提交" cancel-text="关闭">
      <Form :model="editTagUserModal" :label-width="80">
        <FormItem label="用户:" style="width:380px;">
          <span>
            {{editTagUserModal.id}}
            <span v-if="editTagUserModal.realname">_{{editTagUserModal.realname}}</span>
            <span v-if="editTagUserModal.phone">_{{editTagUserModal.phone}}</span>
          </span>
        </FormItem>
        <FormItem label="标签:" style="width:380px;">
          <span>{{editTagUserModal.groupName}}_{{editTagUserModal.tagName}}</span>
        </FormItem>
        <FormItem label="有效期:" required>
          <RadioGroup v-model="editTagUserModal.isTimeLimit">
            <Radio :label="0" style="width: 160px;">不限</Radio>
            <Radio :label="1" style="width: 160px;">限期</Radio>
          </RadioGroup>

          <DatePicker v-if="editTagUserModal.isTimeLimit==1" v-model="editTagUserModal.defaultDate" format="yyyy-MM-dd" type="daterange" 
            placeholder="开始日期～结束日期" style="width:250px; margin-top:20px;"></DatePicker>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Moment from "moment";
import API from "@/api";
import Utils from "../../utils";
import {phoneRegular} from '../../utils/regular'

export default {
  data(){
    return{
      topTitle: '标签用户明细',
      tagGroupAndTaglist: [],
      levelTaglist: [],
      selectTagAry: [],
      isFirstInPage: true,
      indexSelectTagId: '',
      searchParams: {
        tagGroupId: '',
        tagId: '',
        phone: ''
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      addTagUserModal: {
        display: false,
        id: '',
        phone: '',
        tagId: '',
        isTimeLimit: 0,
        clientId: 5,
        defaultDate: [],
        rules:{
          phone: [{
            required: true,
            message: "手机号不能为空",
            trigger: "blur"
          },
          {
            pattern: phoneRegular,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        }
      },
      editTagUserModal: {
        display: false,
        id: '',
        phone: '',
        tagId: '',
        isTimeLimit: 0,
        clientId: 5,
        defaultDate: []
      },
      modalLoading:false,
      phoneVerifyInfo: {
        hadRequst: false,
        verifyResult: false,
        verifyDate: ''
      },
      allClientList: ['','小程序','蓝主人','丽家会Android','丽家会ios','OMS','XMS','小程序','XMS平板','XMS掌柜','管家助手', '商务合作对接'],
      tagUserlist: [],
      isloading: false,
      columnsList:[
        {
          title:'id',
          key:'id',
          align:'center',
          width:100
        },
        {
          title:'用户',
          align:'center',
          width:320,
          render: (h, params) => {
            let user = params.row.userId + '_' + params.row.realname +  '_' + params.row.phone
            return h('span', {}, user)
          }
        },
        {
          title:'标签',
          align:'center',
          width:220,
          render: (h, params) => {
            let user = '【' + params.row.groupName + '】' + params.row.tagName
            return h('span', {}, user)
          }
        },
        {
          title:'有效时间',
          key:'icon',
          align:'center',
          width:280,
          render:(h, params) => {
            if (params.row.isTimeLimit == 1) {
              return ('div', [
                h('p',{},`开始时间: ${Moment(params.row.startTime).format("YYYY-MM-DD hh:mm:ss")}`),
                h('p',{},`结束时间: ${Moment(params.row.endTime).format("YYYY-MM-DD hh:mm:ss")}`)
              ])
            } else {
              return h('div',{}, '无限期')
            }
          }
        },
        {
          title:'备注',
          key:'isEnabled',
          align:'center',
          width:400,
          render:(h, params) => {
            return ('div',[
              h('p',{},`添加: ${['','小程序','蓝主人','丽家会Android','丽家会ios','OMS','XMS','小程序','XMS平板','XMS掌柜','管家助手', '商务合作对接'][params.row.clientId]} | ${params.row.createdName? params.row.createdName: '-'} | ${params.row.createdAt? Moment(params.row.createdAt).format("YYYY-MM-DD hh:mm:ss"): '-'}`),
              h('p',{},`更新: ${params.row.updateName? params.row.updateName: '-'} | ${params.row.updatedAt? Moment(params.row.updatedAt).format("YYYY-MM-DD hh:mm:ss"): '-'}`),
            ])
          }
        },
        {
          title:'操作',
          align:'center',
          width:300,
          render: (h,params) => {
            return h('div',[
              h('Button',{
                props: {
                  type: "primary",
                  size: "small"
                },
                style: {
                  marginRight: "10px"
                },
                on: {
                  click: () => {
                    this.openEditTagUserModalFn(params.row)
                  }
                }
              },'编辑'),
              h('Button',{
                props: {
                  type: "error",
                  size: "small"
                },
                on: {
                  click: () => {
                    this.clickDeleteTagUserFn(params.row.id)
                  }
                }
              },'删除'),
            ])
          }
        }
      ]
    }
  },

  created () {
    let tagType = Utils.getUrlParameterByName( 'tagType' )
    this.tagType = tagType
    let tagGroupId = parseInt(Utils.getUrlParameterByName( 'groupId' ))
    this.searchParams.tagGroupId = tagGroupId
    let tagId = Utils.getUrlParameterByName( 'tagId' )
    if (tagId) {
      this.searchParams.tagId = parseInt(tagId)
    }

    this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.userId = Utils.findFromLocalStorage( "vue-userid" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
    }
    this.getTagUserlistFn()
    this.getTagGroupAndTagFn()
  },

  mounted () {
    this.$Notice.config( {
      top: 200
    });
  },

  methods: {
    async getTagUserlistFn(){
      let params = {
        phone: this.searchParams.phone,
        groupId: this.searchParams.tagGroupId,
        tagId: this.searchParams.tagId,
        pageNum: this.pageParams.pageNum,
        pageSize: this.pageParams.pageSize
      }
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getUserTagList(params, this.protHeaders)).data;
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取标签用户列表数据异常',
            desc: resp.msg
          })
          return
        }
        this.tagUserlist = resp.list
        this.pageParams.total = resp.total
      } catch(e) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    changePageSize(pageSize) {
      this.pageParams.pageNum = 1;
			this.pageParams.pageSize = pageSize;
			this.getTagUserlistFn();
    },

    changePage(page) {
      this.pageParams.pageNum = page;
			this.getTagUserlistFn();
    },

    openAddTagUserModalFn() {
      if (!Utils.hasPermission('tagDetailAdd')) {
        this.$Notice.error({
          title: "无权限操作"
        });
        return
      }

      this.addTagUserModal = Object.assign({}, this.addTagUserModal, {
        display: true,
        id: '',
        phone: '',
        tagId: '',
        isTimeLimit: 0,
        clientId: 5,
        defaultDate: [],
      })
      this.addTagUserModal.tagId = this.indexSelectTagId 

      this.resetPhoneVerifyFn()
    },

    openEditTagUserModalFn(tagUserInfo) {
      if (!Utils.hasPermission('tagDetailEdit')) {
        this.$Notice.error({
          title: "无权限操作"
        });
        return
      }

      this.editTagUserModal = Object.assign({}, this.editTagUserModal, {
        display: true,
        id: tagUserInfo.id,
        realname: tagUserInfo.realname,
        phone: tagUserInfo.phone,
        groupName: tagUserInfo.groupName,
        tagName: tagUserInfo.tagName,
        isTimeLimit: tagUserInfo.isTimeLimit,
        defaultDate: []
      })
      if (tagUserInfo.isTimeLimit == 1) {
        let startTimeShow = Moment( tagUserInfo.startTime ).format( "YYYY-MM-DD")
        let endTimeShow = Moment( tagUserInfo.endTime ).format( "YYYY-MM-DD")
        this.editTagUserModal.defaultDate = [startTimeShow , endTimeShow]
      }
    },

    async getTagGroupAndTagFn(){
      let params = {
        tagType: this.tagType,
      }
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getTagGroupTagList(params, this.protHeaders)).data;
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取标签用户列表数据异常',
            desc: resp.msg
          })
          return
        }
        this.tagGroupAndTaglist = resp
        let levelTaglist = new Array()
        for (let a=0; a<resp.length; a++) {
          if (resp[a].tagList && resp[a].tagList.length>0) {
            let parentItem = {label:resp[a].groupName, value:resp[a].groupId}
            let childAry = new Array()
            for (let b=0; b<resp[a].tagList.length; b++) {
              let childItem = {label:resp[a].tagList[b].name, value:resp[a].tagList[b].id}
              childAry.push(childItem)
            }
            parentItem.children = childAry
            levelTaglist.push(parentItem)
          }
        }
        this.levelTaglist = levelTaglist
        if (this.isFirstInPage) {
          this.getTagAryByGroupId(this.searchParams.tagGroupId)
          this.isFirstInPage = false
        }
      } catch(e) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    preAddUserTagFn() {
      let validResult = false
      this.$refs.addForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        this.$refs.addTagUserModal.buttonLoading = false;
        return;
      }

      if (!this.addTagUserModal.tagId) {
        this.$Notice.error({
          title: '请选择标签',
        })
        this.$refs.addTagUserModal.buttonLoading = false;
        return
      }

      if (this.addTagUserModal.isTimeLimit == 1 && !this.addTagUserModal.defaultDate[0]) {
        this.$Notice.error({
          title: '请选择开始结束时间',
        })
        this.$refs.addTagUserModal.buttonLoading = false;
        return
      }

      let params = {
        phone: this.addTagUserModal.phone.trim(),
        tagId: this.addTagUserModal.tagId,
        clientId: this.addTagUserModal.clientId,
        userName: this.username,
        isTimeLimit: this.addTagUserModal.isTimeLimit,
        sourceId: 4
      }

      if (params.isTimeLimit == 1) {
        params.startTime = this.addTagUserModal.defaultDate[0]? Moment(this.addTagUserModal.defaultDate[0]).format("YYYY-MM-DD 00:00:00"): ''
        params.endTime = this.addTagUserModal.defaultDate[1]? Moment(this.addTagUserModal.defaultDate[1]).format("YYYY-MM-DD 00:00:00"): ''
      }
      this.addNewTagUserFn(params) //请求新增api
    },

    async addNewTagUserFn(params) {
      try {
        let resp = await API.omsAPI[this.env].clientServer.addNewUserTag(params, this.protHeaders);
        this.isloading = false
        if (resp.data.retCode) {
          this.$Notice.error({
            title: '新增标签用户数据异常',
            desc: resp.data.msg
          })
          this.$refs.addTagUserModal.buttonLoading = false;
          return;
        }
        this.addTagUserModal.display = false;
        
        this.$Notice.success({
          title: '新增标签用户成功',
        })
        this.pageParams.pageNum = 1
        this.getTagUserlistFn()
      } catch(err) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    preEditUserTagFn() {
      if (this.editTagUserModal.isTimeLimit == 1 && !this.editTagUserModal.defaultDate[0]) {
        this.$Notice.error({
          title: '请选择开始结束时间',
        })
        this.$refs.editTagUserModal.buttonLoading = false;
        return
      }

      let params = {
        id: this.editTagUserModal.id,
        userName: this.username,
        isTimeLimit: this.editTagUserModal.isTimeLimit,
      }

      if (params.isTimeLimit == 1) {
        params.startTime = this.editTagUserModal.defaultDate[0]? Moment(this.editTagUserModal.defaultDate[0]).format("YYYY-MM-DD 00:00:00"): ''
        params.endTime = this.editTagUserModal.defaultDate[1]? Moment(this.editTagUserModal.defaultDate[1]).format("YYYY-MM-DD 00:00:00"): ''
      }

      this.editTagUserFn(params)
    },

    async editTagUserFn(params) {
      try {
        let resp = await API.omsAPI[this.env].clientServer.editUserTag(params, this.protHeaders);
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '编辑标签用户数据异常',
            desc: resp.msg
          })
          this.$refs.editTagUserModal.buttonLoading = false;
          return
        }
        this.editTagUserModal.display = false
        
        this.$Notice.success({
          title: '编辑标签用户成功',
        })
        this.pageParams.pageNum = 1
        this.getTagUserlistFn()
      } catch(err) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    clickDeleteTagUserFn(id) {
      if (!Utils.hasPermission('tagDetailDel')) {
        this.$Notice.error({
          title: "无权限查看标签组"
        });
        return
      }
      this.$Modal.confirm({
        title: "删除后不可回退，可重新添加用户标签",
        content: "确定删除？",
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.deleteTagUserFn(id)
        }
      });
    },

    async deleteTagUserFn(id) {
      try {
        let params = {
          id: id,
          userName: this.username
        }
        let resp = await API.omsAPI[this.env].clientServer.deleteUserTag(params, this.protHeaders);
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '删除标签用户数据异常',
            desc: resp.msg
          })
          return
        }
        
        this.$Notice.success({
          title: '删除标签用户成功',
        })
        this.pageParams.pageNum = 1
        this.getTagUserlistFn()
      } catch(err) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    forwardToTaglistPageFn() {
      let _url = this.$router ? '#/app/marketing/tagList' : '#/Market/Market/tagList'
      window.open(_url)
    },

    changeTagGroupFn(tagGroupId) {
      this.searchParams.tagId = ""
      this.getTagAryByGroupId(tagGroupId)
    },

    getTagAryByGroupId(tagGroupId) {
      if (tagGroupId) {
        for (let a=0 ; a<this.tagGroupAndTaglist.length; a++) {
          if (tagGroupId == this.tagGroupAndTaglist[a].groupId) {
            this.selectTagAry = this.tagGroupAndTaglist[a].tagList
            break
          }
        }
      } else {
        this.selectTagAry = []
      }
    },

    handleTaguserFn(value, selectedData) {
      if (selectedData.length && selectedData.length>1) {
        this.addTagUserModal.tagId = selectedData[1].value
        this.indexSelectTagId = selectedData[1].value
      } else {
        this.addTagUserModal.tagId = ''
        this.indexSelectTagId = ''
      }
    },

    resetPhoneVerifyFn() {
      this.phoneVerifyInfo = Object.assign({}, this.phoneVerifyInfo, {
        hadRequst: false,
        verifyResult: false,
        verifyDate: ''
      })
    },

    async checkPhoneRegisterFn() {
      try {
        let phoneAvail = phoneRegular.test(this.addTagUserModal.phone.trim())
        if (!phoneAvail) {
          this.$Notice.error({
            title: '请输入正确的手机号',
          })
          return
        }
        let resp = (await API.omsAPI[this.env].clientServer.judgePhoneVerify(this.addTagUserModal.phone.trim(), this.protHeaders)).data;
        let verifyResult = true
        let verifyDate = ''

        if (resp.retCode) {
          if (resp.retCode == 41020006) {
            verifyResult = false
          } else if(!resp.data.openId){
            verifyResult = false
          }
        } else {
          if (resp.createdAt) {
            verifyDate = Moment(resp.createdAt).format("YYYY-MM-DD hh:mm:ss")
          }
        }
        
        this.phoneVerifyInfo = Object.assign({}, this.phoneVerifyInfo, {
          hadRequst: true,
          verifyResult: verifyResult,
          verifyDate: verifyDate
        })
        
      } catch(e) {
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.colorUnderline {
  margin-top: 8px;
  color:blue;
  text-decoration: underline;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/marketing/tagDetailList.vue